export default [
    {
        name: "loadTestCase",
        path: "/test-cases/:id",
        component: () => import(/* webpackChunkName: "test" */ "@/views/test/LoadTestCaseView.vue"),
        meta: {
        },
    },
]
